export default function mainScrollTop() {
  document.querySelector(".main-body").scrollTop = 0;
}
